// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"loader_loader-container__jU_jF","lds-ripple":"loader_lds-ripple__nyAVf","lds-roller":"loader_lds-roller___jPyU"};